import { NavBar } from './components/nav-bar/nav-bar';
import { Home } from './components/home/home';
import { AboutMe } from './components/about-me/about-me';
import { Treatments } from './components/treatments/treatments';
import { Faq } from './components/faq/faq';
import { Testimonials } from './components/testimonials/testimonials';
import { Contact } from './components/contact/contact';
import { Footer } from './components/footer/footer';
import { BackToTop } from './components/common/back-to-top';
import { AgendaButton } from './components/agenda/agenda-button';
import './App.css';

function App() {
  return (
    <>
      {/* Skip link for keyboard users */}
      <a href="#main-content" className="skip-link">
        Saltar al contenido principal
      </a>

      <NavBar />

      <main id="main-content" tabIndex="-1">
        <Home />
        <AboutMe />
        <Treatments />
        <Faq />
        <Contact />
        <Testimonials />
      </main>

      <Footer />
      <BackToTop />
      <AgendaButton />
    </>
  );
}

export default App;
